@if (showPanel) {
    <div data-qa="messages" fxFlex="80px" fxLayout="column" fxLayoutAlign="space-around stretch">
        <img src="/assets/innogy-icons/innogy_picto_docs_exclamation-mark.svg">
    </div>
    <div data-qa="messages" fxFlex="60" fxLayout="column" fxLayoutAlign="space-around start">
        <p>
            Es existiert eine Datenabfrage zum Aufteilungsschlüssel mit der Bezeichnung
            <strong>'{{ aktiveDatenAbfrage.bezeichnung }}'</strong>,
            zu der eine Dateneingabe erforderlich ist. Bitte tragen
            Sie die jeweiligen Daten ein.
        </p>
        <ul>
            <li>Abgabefrist: {{ aktiveDatenAbfrage.abgabefrist | date: 'dd.MM.yyyy' }}</li>
            <li>Referenzzeitraum für
                Erzeugerleistung: {{ aktiveDatenAbfrage.referenzzeitraumErzeugerleistung | date: 'dd.MM.yyyy' }}
            </li>
            <li>Referenzzeitraum für
                Endverbraucherlast: {{ aktiveDatenAbfrage.referenzzeitraumEndverbraucherlast | date: 'dd.MM.yyyy' }}
            </li>
        </ul>
        <a [queryParamsHandling]="'merge'" [queryParams]="{datenabfrage: aktiveDatenAbfrage.id}"
           [routerLink]="['/datenabfrage/datenabfrage-page']"
           class="datenabfrage-link"
           matButton="filled">Datenabfrage
        </a>
    </div>
    <div class="notify-badge" data-qa="link" fxFlex="33" fxLayoutAlign="center center">
        <div class="badge-text">Jetzt aktualisieren</div>
    </div>
}
